<template>
  <div class="config-app">
    <h2 class="app-title">Gestão de Processos</h2>
    <p class="subtitle">Permite você habilitar e configurar as preferências do módulo de processos.</p>

    <app-tab :active="active" :menu="menu" @changeTab="(item) => active = item.name">
      <div v-if="active === 'basico'" class="app-input-container app-input-row">
        <app-label>Ativar Robôs PJe</app-label>
        <app-label-content>
          <u-select :options="[{label: 'Sim', value: '1'},{label: 'Não', value: '0'}]" class="app-input" hide-underline v-model="c('processsos.robos.pje').value" />
          <p class="app-legend m-t-xs m-b-none">Habilita robôs para comunicar com os tribunais e buscar andamentos processuais</p>
          <div class="m-t">
            <u-btn @click="$emit('salvar')" label="Salvar configuações" no-caps color="green" class="app-btn" />
          </div>
        </app-label-content>
      </div>
      <list v-if="active === 'status'" class="app-input-container" />
      <list-classificacao v-if="active === 'classificacao'" class="app-input-container" />
      <list-tipos-parte v-if="active === 'tiposParte'" class="app-input-container" />
    </app-tab>
  </div>
</template>

<script>
import AppMixin from './appMixin'
import List from "@/components/cadastro/components/statusprocesso/List"
import ListClassificacao from "@/components/cadastro/components/classificacaoprocesso/List"
import ListTiposParte from "@/components/cadastro/components/tiposparteprocesso/List"
import {USelect} from "uloc-vue"

export default {
  name: "ConfigProcessos",
  components: {
    List,
    ListClassificacao,
    ListTiposParte,
    USelect
  },
  mixins: [AppMixin],
  data() {
    return {
      active: 'basico'
    }
  },
  computed: {
    menu() {
      return [
        {
          name: 'basico',
          label: 'Básico'
        },
        {
          name: 'status',
          label: 'Status de Processos'
        },
        {
          name: 'classificacao',
          label: 'Classificação de Processos'
        },
        {
          name: 'tiposParte',
          label: 'Tipos de Parte'
        }
      ]
    }
  }
}
</script>
